import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Segment } from 'components/UI'

const Wrapper = styled.div`
  text-align: center;
`
const Value = styled.h1`
  margin: 0;
  color: ${({color}) => color || 'inherit'};
`
const Description = styled.p`
  font-weight: bold;
`
const StatLink = styled(Link)`
  color: inherit;

  &:hover {
    color: ${({color}) => color || 'inherit'};
  }
`

const Statistic = ({ value, description, color, link }) => {
  const content = (
    <Segment centered>
      <Wrapper>
        <Value color={color}>{value}</Value>
        <Description>{description}</Description>
      </Wrapper>
    </Segment>
  )

  const linkedContent = (
    <StatLink to={link || '#'} color={color}>
      {content}
    </StatLink>
  )

  return link ? linkedContent : content
}

export default Statistic



// WEBPACK FOOTER //
// ./src/components/UI/Statistic.jsx